/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Crown-Bronze': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M2.667 9.333l8 4.267L16 6.667l6.667 6.933 6.666-4.267-1.333 16H4l-1.333-16z" _fill="#DAA188"/><path pid="1" d="M16.24 22.14c1.41 0 2.6-.79 2.6-2.15 0-.97-.64-1.59-1.48-1.82v-.05c.79-.31 1.24-.89 1.24-1.69 0-1.27-.97-1.97-2.4-1.97-.87 0-1.58.35-2.22.91l.75.9c.44-.4.87-.65 1.4-.66.63.01.99.35.99.93 0 .66-.44 1.13-1.8 1.13v1.06c1.61 0 2.04.45 2.04 1.18 0 .66-.51 1.03-1.26 1.03-.67 0-1.21-.33-1.65-.76l-.69.93c.52.59 1.31 1.03 2.48 1.03z" _fill="#fff"/>'
  }
})
